import _styled from "@emotion/styled";
// Re-export emotion's `styled` with Stencil specific types
export var styledWithTheme = _styled;